module.exports = {
	"loads": {
		"0": {
			"points": {
				"2017-01-15 00:00": {
					"title": "Winternacht - Kein Verbrauch",
					"description": "Die Brennstoffzelle laedt die Batterie.",
					"units": {
						"pv": 0,
						"ld": 0,
						"hy": 297.5,
						"bt": 12.5,
						"ht": 0.7
					},
					"flows": {
						"pv-ld": 0,
						"pv-el": 0,
						"pv-bt": 0,
						"fc-ld": 0,
						"fc-bt": 1.5,
						"bt-el": 0,
						"bt-ld": 0
					}
				},
				"2017-01-15 12:00": {
					"title": "Wintertag - Kein Verbrauch",
					"description": "Die Solaranlage laedt die Batterie.",
					"units": {
						"pv": 5,
						"ld": 0,
						"hy": 297.5,
						"bt": 12.5,
						"ht": 0.7
					},
					"flows": {
						"pv-ld": 0,
						"pv-el": 0,
						"pv-bt": 5,
						"fc-ld": 0,
						"fc-bt": 0,
						"bt-el": 0,
						"bt-ld": 0
					}
				},
				"2017-07-15 00:00": {
					"title": "Sommernacht - Kein Verbrauch",
					"description": "Picea ist im Stand-by Modus.",
					"units": {
						"pv": 0,
						"ld": 0,
						"hy": 175,
						"bt": 21.3,
						"ht": 1.9
					},
					"flows": {
						"pv-ld": 0,
						"pv-el": 0,
						"pv-bt": 0,
						"fc-ld": 0,
						"fc-bt": 0,
						"bt-el": 0,
						"bt-ld": 0
					}
				},
				"2017-07-15 12:00": {
					"title": "Sommertag - Kein Verbrauch",
					"description": "Die Solarnanlage laedt Batterie und Wasserstoffspeicher.",
					"units": {
						"pv": 10,
						"ld": 0,
						"hy": 175,
						"bt": 21.3,
						"ht": 0.2
					},
					"flows": {
						"pv-ld": 0,
						"pv-el": 2.6,
						"pv-bt": 7.4,
						"fc-ld": 0,
						"fc-bt": 0,
						"bt-el": 0,
						"bt-ld": 0
					}
				}
			}
		},
		"1": {
			"points": {
				"2017-01-15 00:00": {
					"title": "Winternacht - Geringer Verbrauch",
					"description": "Die Brennstoffzelle deckt Stromverbrauch und laedt Batterie.",
					"units": {
						"pv": 0,
						"ld": 1,
						"hy": 297.5,
						"bt": 12.5,
						"ht": 0.2
					},
					"flows": {
						"pv-ld": 0,
						"pv-el": 0,
						"pv-bt": 0,
						"fc-ld": 1,
						"fc-bt": 0.5,
						"bt-el": 0,
						"bt-ld": 0
					}
				},
				"2017-01-15 12:00": {
					"title": "Wintertag - Geringer Verbrauch",
					"description": "Die Solaranlage deckt den Stromverbrauch und laedt die Batterie.",
					"units": {
						"pv": 5,
						"ld": 1,
						"hy": 297.5,
						"bt": 12.5,
						"ht": 1.6
					},
					"flows": {
						"pv-ld": 1,
						"pv-el": 0,
						"pv-bt": 4,
						"fc-ld": 0,
						"fc-bt": 0,
						"bt-el": 0,
						"bt-ld": 0
					}
				},
				"2017-07-15 00:00": {
					"title": "Sommernacht - Geringer Verbrauch",
					"description": "Die Batterie deckt den Stromverbrauch.",
					"units": {
						"pv": 0,
						"ld": 1,
						"hy": 175,
						"bt": 21.3,
						"ht": 0
					},
					"flows": {
						"pv-ld": 0,
						"pv-el": 0,
						"pv-bt": 0,
						"fc-ld": 0,
						"fc-bt": 0,
						"bt-el": 0,
						"bt-ld": 1
					}
				},
				"2017-07-15 12:00": {
					"title": "Sommertag - Geringer Verbrauch",
					"description": "Die Solaranlage deckt den Stromverbrauch und laedt Batterie und Wasserstoffspeicher.",
					"units": {
						"pv": 10,
						"ld": 1,
						"hy": 175,
						"bt": 21.3,
						"ht": 0
					},
					"flows": {
						"pv-ld": 1,
						"pv-el": 2.6,
						"pv-bt": 6.4,
						"fc-ld": 0,
						"fc-bt": 0,
						"bt-el": 0,
						"bt-ld": 0
					}
				}
			}
		},
		"10": {
			"points": {
				"2017-01-15 00:00": {
					"title": "Winternacht - Hoher Verbrauch",
					"description": "Die Brennstoffzelle und Batterie decken den Stromverbrauch.",
					"units": {
						"pv": 0,
						"ld": 10,
						"hy": 297.5,
						"bt": 12.5,
						"ht": 0
					},
					"flows": {
						"pv-ld": 0,
						"pv-el": 0,
						"pv-bt": 0,
						"fc-ld": 1.5,
						"fc-bt": 0,
						"bt-el": 0,
						"bt-ld": 8.5
					}
				},
				"2017-01-15 12:00": {
					"title": "Wintertag - Hoher Verbrauch",
					"description": "Solaranlage, Batterie und Brennstoffzelle decken den Stromverbrauch.",
					"units": {
						"pv": 5,
						"ld": 10,
						"hy": 297.5,
						"bt": 12.5,
						"ht": 0.8
					},
					"flows": {
						"pv-ld": 5,
						"pv-el": 0,
						"pv-bt": 0,
						"fc-ld": 1.5,
						"fc-bt": 0,
						"bt-el": 0,
						"bt-ld": 3.5
					}
				},
				"2017-07-15 00:00": {
					"title": "Sommernacht - Hoher Verbrauch",
					"description": "Die Batterie deckt den Stromverbrauch.",
					"units": {
						"pv": 0,
						"ld": 10,
						"hy": 175,
						"bt": 21.3,
						"ht": 0.8
					},
					"flows": {
						"pv-ld": 0,
						"pv-el": 0,
						"pv-bt": 0,
						"fc-ld": 0,
						"fc-bt": 0,
						"bt-el": 0,
						"bt-ld": 10
					}
				},
				"2017-07-15 12:00": {
					"title": "Sommertag - Hoher Verbrauch",
					"description": "Die Solaranlage deckt den Stromverbrauch.",
					"units": {
						"pv": 10,
						"ld": 10,
						"hy": 175,
						"bt": 21.3,
						"ht": 0
					},
					"flows": {
						"pv-ld": 10,
						"pv-el": 0,
						"pv-bt": 0,
						"fc-ld": 0,
						"fc-bt": 0,
						"bt-el": 0,
						"bt-ld": 0
					}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/data.json
// module id = ./src/config/data.json
// module chunks = 0